import { createStore, compose, applyMiddleware } from "redux";
import reducer from './reducers';
import thunk from "redux-thunk";
import { getFirebase } from "react-redux-firebase";
import { createEpicMiddleware } from "redux-observable";
import Epics from './epics';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__?: typeof compose;
  }
}

const epicMiddleware = createEpicMiddleware();

const middlewares = [
  thunk.withExtraArgument(getFirebase),
  epicMiddleware,
];

const store = createStore(
  reducer,
  compose(
    applyMiddleware(...middlewares),
    typeof window === 'object' &&
      typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f: unknown) => f

  )
);

epicMiddleware.run(Epics as any);

export default store;